/** Formateadores del módulo aéreo (los del LCL viven en `lcl-requests/utils`). */
export const shortId = (id) => (id ? String(id).slice(-6) : '—');
export const formatCodigo = (r) => r?.codigo || shortId(r?._id);
export const formatCliente = (r) => r?.clienteSnapshot?.nombre || shortId(r?.clienteId);

/** IATA de origen → IATA de destino. */
export const formatRuta = (r) => {
  const a = r?.aeropuertoCargaSnapshot;
  const b = r?.aeropuertoDescargaSnapshot;
  const li = a?.iata || a?.ciudad || shortId(r?.aeropuertoCargaId);
  const ri = b?.iata || b?.ciudad || shortId(r?.aeropuertoDescargaId);
  return `${li} → ${ri}`;
};

export const formatDate = (v) => {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: '2-digit' });
};

export const kg = (n) =>
  Number(n || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
